import { HttpClient, HttpHeaders, HttpParams, HttpParamsOptions } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable, map } from "rxjs";
import { APP_CONFIG } from "../app.config";
import { AppConfig } from "../models/app.config";
import { AppConfigService } from "./app-config.service";

@Injectable({
    providedIn: "root"
})
export class ApiService {

    public serviceUrl: string = "";

    constructor(private http: HttpClient,
        private appConfigService: AppConfigService,
        @Inject(APP_CONFIG) config: AppConfig) {
        this.serviceUrl = this.ensureEndsWith(this.appConfigService.getConfig().apiUri, '/');
    }

    private apiUrl(url: string) {
        return `${this.serviceUrl}${url}`;
    }

    public get<T>(url: string, params: HttpParams = new HttpParams()): Observable<T> {
        return this.http.get<T>(this.apiUrl(url), { params: params })
            .pipe(
                map((response: any) => response),
            );
    }

    public post<T>(url: string, body?: any, params: HttpParams = new HttpParams()): Observable<T> {
        const headers = new HttpHeaders().set('Content-Type', 'application/json');


        const options = { params: params, headers: headers };

        return this.http.post<T>(this.apiUrl(url), body, options)
            .pipe(
                map((response: any) => response),
            );
    }

    private ensureEndsWith(str: string, letter: string): string {
        const regex = new RegExp(`${letter}$`, 'i');
        if (regex.test(str)) {
            return str;
        } else {
            return str + letter;
        }
    }
}
